import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
// import InstallPrompt from "../components/InstallPrompt";

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Navbar />

      {/* Hero Section */}
      <div className="flex flex-col items-center justify-center text-center px-4 md:px-6 py-16 md:py-24">
        <span className="bg-purple-900 text-purple-300 text-sm px-4 py-1 rounded-full mb-6">
          AI-Powered Script Generator
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          Generate{" "}
          <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Video Scripts
          </span>{" "}
          in Seconds
        </h1>

        <p className="text-gray-400 text-base md:text-xl max-w-2xl mb-10">
          TubeScript AI generates professional scripts, titles, descriptions,
          hashtags and thumbnail ideas for YouTube, TikTok, Instagram and more —
          in seconds!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <button
            onClick={() => navigate("/register")}
            className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-xl text-lg font-semibold transition"
          >
            Start For Free
          </button>
          <button
            onClick={() => navigate("/pricing")}
            className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-xl text-lg font-semibold transition"
          >
            View Pricing
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 md:gap-12 mt-16 md:mt-20">
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-purple-400">
              2
            </h3>
            <p className="text-gray-400 mt-1 text-xs md:text-base">
              Free Scripts/Month
            </p>
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-purple-400">
              10s
            </h3>
            <p className="text-gray-400 mt-1 text-xs md:text-base">
              Generation Time
            </p>
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-purple-400">
              ∞
            </h3>
            <p className="text-gray-400 mt-1 text-xs md:text-base">
              Topics Supported
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-gray-800 py-16 md:py-20 px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-12">
          Everything You Need To{" "}
          <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Grow Your Channel
          </span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {[
            {
              icon: "📝",
              title: "Full Video Script",
              desc: "Complete scripts with HOOK, INTRO, MAIN CONTENT and OUTRO sections",
            },
            {
              icon: "🎯",
              title: "SEO Optimized Title",
              desc: "Catchy titles designed to get more clicks and views",
            },
            {
              icon: "#️⃣",
              title: "Hashtags & Description",
              desc: "Ready-to-use descriptions and hashtags for maximum reach",
            },
            {
              icon: "🖼️",
              title: "Thumbnail Ideas",
              desc: "3 creative thumbnail concepts to make your video stand out",
            },
            {
              icon: "🌍",
              title: "Any Niche",
              desc: "Works for Health, Tech, Finance, Food, Travel and any other niche",
            },
            {
              icon: "📱",
              title: "All Platforms",
              desc: "Scripts for YouTube, TikTok, Instagram Reels and more",
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="bg-gray-900 p-6 rounded-xl border border-gray-700 hover:border-purple-500 transition"
            >
              <span className="text-4xl">{feature.icon}</span>
              <h3 className="text-lg md:text-xl font-semibold mt-4 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 md:py-20 px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold mb-6">
          Ready To Create Amazing Content?
        </h2>
        <p className="text-gray-400 text-base md:text-lg mb-8">
          Join thousands of creators using TubeScript AI to grow their channels!
        </p>
        <button
          onClick={() => navigate("/register")}
          className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white px-10 py-4 rounded-xl text-lg font-semibold transition"
        >
          Get Started For Free
        </button>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 border-t border-gray-800 py-8 px-4 md:px-6 text-center text-gray-400 text-sm md:text-base">
        <p>© 2026 TubeScript AI. Built by Muoghalu Ijeoma Florence</p>
      </footer>
    </div>
  );
};

export default Landing;
